import { FunctionComponent, useMemo } from 'react'
import { Illustration as IconographyIllustration } from '@conexasaude/iconography/illustrations'
import { IllustrationProps } from './types'
import { useThemeGeneratorContext } from '@/theme/contexts/ThemeGeneratorContext'
import { RenderIf } from '../RenderIf'

export const Illustration: FunctionComponent<IllustrationProps> = ({
  css,
  hide,
  name,
  ...rest
}) => {
  const {
    theme: { controls },
  } = useThemeGeneratorContext()

  const hideIllustration = useMemo(() => {
    if (hide === undefined) return controls?.flagDesabilitarIlustracoes
    else return hide
  }, [hide, controls?.flagDesabilitarIlustracoes])

  return (
    <RenderIf condition={!hideIllustration}>
      <IconographyIllustration css={css} name={name} {...rest} />
    </RenderIf>
  )
}
